/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProtobufAny,
    ProtobufAnyFromJSON,
    ProtobufAnyFromJSONTyped,
    ProtobufAnyToJSON,
} from './ProtobufAny';

/**
 * 
 * @export
 * @interface RuntimeStreamError
 */
export interface RuntimeStreamError {
    /**
     * 
     * @type {Array<ProtobufAny>}
     * @memberof RuntimeStreamError
     */
    details?: Array<ProtobufAny>;
    /**
     * 
     * @type {number}
     * @memberof RuntimeStreamError
     */
    grpcCode?: number;
    /**
     * 
     * @type {number}
     * @memberof RuntimeStreamError
     */
    httpCode?: number;
    /**
     * 
     * @type {string}
     * @memberof RuntimeStreamError
     */
    httpStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof RuntimeStreamError
     */
    message?: string;
}

export function RuntimeStreamErrorFromJSON(json: any): RuntimeStreamError {
    return RuntimeStreamErrorFromJSONTyped(json, false);
}

export function RuntimeStreamErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeStreamError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'details': !exists(json, 'details') ? undefined : ((json['details'] as Array<any>).map(ProtobufAnyFromJSON)),
        'grpcCode': !exists(json, 'grpcCode') ? undefined : json['grpcCode'],
        'httpCode': !exists(json, 'httpCode') ? undefined : json['httpCode'],
        'httpStatus': !exists(json, 'httpStatus') ? undefined : json['httpStatus'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function RuntimeStreamErrorToJSON(value?: RuntimeStreamError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'details': value.details === undefined ? undefined : ((value.details as Array<any>).map(ProtobufAnyToJSON)),
        'grpcCode': value.grpcCode,
        'httpCode': value.httpCode,
        'httpStatus': value.httpStatus,
        'message': value.message,
    };
}

